import {
  CheckCircle2,
  Users,
  MessagesSquare,
  Network,
  Compass,
  Flame,
  CalendarClock,
  LineChart,
  BarChart3,
  Sparkles,
  Wrench,
} from "lucide-react";

// Un color + ícono por categoría del blog "Rompiendo el techo".
// Se usa tanto en el índice del blog (tarjetas + chips de filtro) como en el
// detalle de cada artículo (chip de categoría), para que sean siempre consistentes.
export const CATEGORY_STYLES = {
  "Accountability": { accent: "#F26522", bg: "#FFF4EC", border: "#FCD9BE", icon: CheckCircle2 },
  "Personas": { accent: "#0EA5E9", bg: "#EFF8FF", border: "#BEE3FB", icon: Users },
  "Equipo de Liderazgo": { accent: "#8B5CF6", bg: "#F5F1FF", border: "#DDD1FA", icon: MessagesSquare },
  "Estructura": { accent: "#0D9488", bg: "#EDFBF8", border: "#BBEEE3", icon: Network },
  "Liderazgo": { accent: "#D97706", bg: "#FFF7E8", border: "#FCE1A8", icon: Compass },
  "Visión y Prioridades": { accent: "#DC2626", bg: "#FEF0EF", border: "#F9C8C4", icon: Flame },
  "Reuniones": { accent: "#2563EB", bg: "#EEF3FF", border: "#C3D6FB", icon: CalendarClock },
  "Datos y Rentabilidad": { accent: "#059669", bg: "#ECFBF3", border: "#B7EED2", icon: LineChart },
  "Datos": { accent: "#0891B2", bg: "#ECFAFD", border: "#BAE9F3", icon: BarChart3 },
  "Inteligencia Artificial": { accent: "#4338CA", bg: "#EEF0FF", border: "#C7D0FC", icon: Sparkles },
  "Herramientas": { accent: "#475569", bg: "#F1F5F9", border: "#CBD5E1", icon: Wrench },
};

export const DEFAULT_CATEGORY_STYLE = CATEGORY_STYLES["Accountability"];
